import { clearInstructions, clearPageInstructionReferences } from '../../../page-instructions';
import {
  ADD_CONTAINER_ITEM,
  UPDATE_CONTAINER_ITEM,
  REPLACE_CONTAINER_ITEM,
  REMOVE_CONTAINER_ITEM,
  CLEAR_TRANSIENT_DATA
} from '../actions';

/**
 * Redux middleware to track the redux changes
 * and manipulate the data reference data
 * @param store the store that will be affected
 */

const DataReferenceMiddleware = () => (next: any) => (action: any) => {
  const { payload: { context = null, transientItemID = null, clearStateMachine = true } = {}, type } = action;

  if (
    context &&
    (type === ADD_CONTAINER_ITEM ||
      type === UPDATE_CONTAINER_ITEM ||
      type === REPLACE_CONTAINER_ITEM ||
      type === REMOVE_CONTAINER_ITEM) &&
    clearStateMachine
  ) {
    clearInstructions(context);
    clearPageInstructionReferences(context);
  }

  if (transientItemID && type === CLEAR_TRANSIENT_DATA) {
    clearInstructions(transientItemID);
    clearPageInstructionReferences(transientItemID);
  }

  next(action);
};

export default DataReferenceMiddleware;
